
export default function EditEscrowModal({description, onContinue, onClose }) {
  return (
    <div className="modelspace pplication-fe">        
            <p className="model-desc-details notice-icon">Changing the {description} will affect the estimate.</p>
           <div className="frm-btn popup-2-btn">
                
                <button className="submit-btn btn-bg inpt-btn btn-discard" onClick={onClose}>Cancel</button>
                <button className="submit-btn btn-bg inpt-btn" onClick={() => onContinue(false)}>Continue</button>
          </div>
    </div>
  );
}
